export default __webpack_public_path__ + "static/media/B02.edf40aa7.png";